import { useCallback } from "react";
import {
  resetSnapFeedState,
  SNAP_FEED_CLASS_NAME,
  SNAP_ROOT_SELECTOR
} from "@/common/utils/snapFeedUtils";

export const useExitSnapFeed = () => {
  const exitSnapFeed = useCallback(() => {
    if (typeof document === "undefined") {
      return;
    }

    const rootElement = document.querySelector(SNAP_ROOT_SELECTOR);
    const previewFeed = document.querySelector(".previewFeed");

    if (previewFeed instanceof HTMLElement) {
      previewFeed.scrollTo({ top: 0, behavior: "auto" });
    }

    if (rootElement instanceof HTMLElement && rootElement.classList.contains(SNAP_FEED_CLASS_NAME)) {
      resetSnapFeedState(rootElement);
    }
  }, []);

  return exitSnapFeed;
};
